import { useEffect } from "react";
import { Provider } from "react-redux";
import {
  axiosInstance,
  requestFailure,
  requestSuccess,
} from "./core/http/httpClient";
import { assetActions } from "./ducks/asset";
import { RouteConfig } from "./RouteConfig";
import { store } from "./store";
import { dataActions } from "./ducks/data";

function App() {
  useEffect(() => {
    store.dispatch(assetActions.fetchMessages.started({}));
    store.dispatch(dataActions.getMaintenanceJson.started({}));

    axiosInstance.interceptors.response.use(
      (config) => requestSuccess(config),
      (config) => requestFailure(config, store),
    );
  }, []);

  return (
    <Provider store={store}>
      <RouteConfig />
    </Provider>
  );
}

export default App;
